module.exports = __webpack_public_path__ + "static/img/products_01.7caf7cf2.png";